import { render, staticRenderFns } from "./error.vue?vue&type=template&id=9df3a206&scoped=true"
var script = {}
import style0 from "./error.vue?vue&type=style&index=0&id=9df3a206&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9df3a206",
  null
  
)

export default component.exports